import { featuredSheets, trendingItems } from "@/mocks/categories";

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="mb-12 flex flex-col lg:flex-row lg:items-end justify-between gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Featured Spreadsheets
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-md">
              Hand-picked pandabuy spreadsheet collections loved by the community.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
          >
            View all collections
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuredSheets.map((sheet, idx) => (
            <a
              key={idx}
              href={sheet.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group rounded-3xl overflow-hidden border border-background-200 transition-all hover:border-accent-200 cursor-pointer ${
                idx === 0 ? "bg-foreground-900" : "bg-white"
              }`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={sheet.image}
                  alt={sheet.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {idx > 0 && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-white/90 text-xs font-medium text-foreground-800 rounded-full">
                    Trending
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className={`font-heading font-bold text-lg leading-snug ${idx === 0 ? "text-white" : "text-foreground-950"}`}>
                  {sheet.title}
                </h3>
                <p className={`mt-1.5 text-sm leading-relaxed ${idx === 0 ? "text-white/60" : "text-foreground-500"}`}>
                  {sheet.description}
                </p>
                <span className={`inline-flex items-center gap-1.5 mt-4 text-sm font-medium ${idx === 0 ? "text-accent-400" : "text-accent-600"} group-hover:gap-2 transition-all`}>
                  View Spreadsheet
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="text-xl font-heading font-bold text-foreground-950 mb-6">Live Trending Finds</h3>
          <div className="overflow-x-auto rounded-2xl border border-background-200">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-200/50">
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Item</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Category</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Price</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Trend</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Quality</th>
                  <th className="px-5 py-3.5"></th>
                </tr>
              </thead>
              <tbody>
                {trendingItems.map((item, idx) => (
                  <tr key={idx} className="border-t border-background-200 hover:bg-background-50 transition-colors">
                    <td className="px-5 py-3.5 font-medium text-foreground-900">{item.item}</td>
                    <td className="px-5 py-3.5 text-foreground-600">{item.category}</td>
                    <td className="px-5 py-3.5 font-semibold text-accent-600">{item.price}</td>
                    <td className="px-5 py-3.5">{item.trend}</td>
                    <td className="px-5 py-3.5 text-foreground-500">{item.quality}</td>
                    <td className="px-5 py-3.5">
                      <a
                        href="https://kaspreadsheet.com"
                        target="_blank"
                        rel="noopener nofollow"
                        className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-accent-600 hover:text-accent-700 bg-accent-50 hover:bg-accent-100 rounded-full transition-colors cursor-pointer whitespace-nowrap"
                      >
                        View
                        <i className="ri-arrow-right-up-line"></i>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}